@let e = entry();
<div class="when">
  {{ e.at | date: 'd MMM y' }}
  @if (!e.upcoming) {
    <br />{{ e.at | date: 'HH:mm' }}
  }
</div>
<div class="body">
  <span class="origin-tag" [attr.data-origin]="e.origin.key">{{ e.origin.label }}</span>
  @if (e.subject; as subject) {
    <span class="subject-tag" [attr.data-origin]="subject.origin.key">{{ subject.label }}</span>
  }
  <div class="title"><app-history-text [text]="e.title" /></div>
  @for (line of e.lines ?? []; track $index) {
    <div class="line" [attr.data-tone]="line.tone ?? null">
      <app-history-text [text]="line.text" />
    </div>
  }
  @if (e.comment) {
    <div class="comment">« {{ e.comment }} »</div>
  }
  @if (expanded()) {
    <ul class="details">
      @for (detail of e.details ?? []; track $index) {
        <li class="detail">
          <span class="who"><app-history-text [text]="detail.label" /></span>
          <span class="fate" [attr.data-tone]="detail.tone ?? null">{{ detail.value }}</span>
        </li>
      }
    </ul>
  }
</div>
<div class="tools">
  @if (e.action; as action) {
    <button
      mat-icon-button
      type="button"
      [matTooltip]="action.label"
      [attr.aria-label]="action.label"
      (click)="action.run()"
    >
      <svg lucideEye></svg>
    </button>
  }
  @if (e.details?.length) {
    <button
      mat-icon-button
      type="button"
      [attr.aria-expanded]="expanded()"
      [attr.aria-label]="expanded() ? 'Replier' : 'Déplier'"
      (click)="toggle()"
    >
      <mat-icon>{{ expanded() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
    </button>
  }
</div>
